<script>
import {
  ActionBar,
  ActionBarTitle,
  //ActionBarButton
} from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { GoldFillService, GoldTransferService } from '@/services'

const Fill = () => import('./Fill.vue')
const Receive = () => import('./Receive.vue')
const Transfer = () => import('./Transfer.vue')

export default {
  data() {
    const { query } = this.$route

    return {
      fill: {
        items: [],
        pagination: {
          page: Number(query.fill_page) || 1,
          total: 100,
          pageSize: 10
        },
        isLoading: false
      },
      receive: {
        items: [],
        pagination: {
          page: Number(query.receive_page) || 1,
          total: 100,
          pageSize: 10
        },
        isLoading: false
      },
      transfer: {
        items: [],
        pagination: {
          page: Number(query.transfer_page) || 1,
          total: 100,
          pageSize: 10
        },
        isLoading: false
      }
    }
  },

  created() {
    this.fetchFill()
    this.fetchReceive()
    this.fetchTransfer()
  },

  methods: {
    toCreatePage(type) {
      this.$router.push({ name: 'GoldTransferCreate', params: { type } })
    },

    toHistoryPage() {
      this.$router.push({ name: 'GoldTransferHistory' })
    },

    async fetchFill() {
      this.fill.isLoading = true

      try {
        const {
          data: { result }
        } = await GoldFillService.getAll({
          status: ['pending', 'requested'],
          page: this.fill.pagination.page
        })

        this.fill.items = result.results.map(item => ({
          id: item.id,
          date: new Date(item.datetime),
          invoiceId: item.invoice_id,
          store: item.supplier_company ? item.supplier_company.name : '',
          weight: +item.total_weight,
          status: item.status
        }))

        this.fill.pagination.total = result.count
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.fill.isLoading = false
      }
    },

    async fetchReceive() {
      this.receive.isLoading = true

      try {
        const {
          data: { result }
        } = await GoldTransferService.getAll({
          status: ['pending', 'requested'],
          gold_type: ['sellgold', 'usedgold'],
          is_inbound: true,
          page: this.receive.pagination.page
        })

        this.receive.items = result.results.map(item => ({
          id: item.id,
          date: new Date(item.datetime),
          origin: item.branch ? item.branch.name : '',
          type: { goldtransfer: 'sell', usedgoldtransfer: 'old' }[
            item._content_type.model
          ],
          weight: +item.total_baht_weight,
          realWeight: +item.total_real_weight,
          status: item.status
        }))

        this.receive.pagination.total = result.count
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.receive.isLoading = false
      }
    },

    async fetchTransfer() {
      this.transfer.isLoading = true

      try {
        const {
          data: { result }
        } = await GoldTransferService.getAll({
          status: ['pending', 'requested'],
          gold_type: ['sellgold', 'usedgold'],
          is_inbound: false,
          page: this.transfer.pagination.page
        })

        this.transfer.items = result.results.map(item => ({
          id: item.id,
          date: new Date(item.datetime),
          destination: item.to_branch.name,
          type: { goldtransfer: 'sell', usedgoldtransfer: 'old' }[
            item._content_type.model
          ],
          weight: +item.total_baht_weight,
          realWeight: +item.total_real_weight,
          status: item.status
        }))

        this.transfer.pagination.total = result.count
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.transfer.isLoading = false
      }
    },

    handleFillPageChange(page) {
      this.fill.pagination.page = page

      this.$router.replace({ query: { ...this.$route.query, fill_page: page } })

      this.fetchFill()
    },

    handleReceivePageChange(page) {
      this.receive.pagination.page = page

      this.$router.replace({
        query: { ...this.$route.query, receive_page: page }
      })

      this.fetchReceive()
    },

    handleTransferPageChange(page) {
      this.transfer.pagination.page = page

      this.$router.replace({
        query: { ...this.$route.query, transfer_page: page }
      })

      this.fetchTransfer()
    }
  },

  render() {
    return (
      <div>
        <ActionBar>
          <el-button
            slot="action"
            type="primary"
            onClick={() => {
              this.toCreatePage('old')
            }}
          >
            โอนทองเก่า
          </el-button>
          <el-button
            slot="action"
            type="primary"
            onClick={() => {
              this.toCreatePage('sell')
            }}
          >
            โอนทองขายหน้าร้าน
          </el-button>
          <ActionBarTitle>การโอนย้ายทอง</ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <Fill
              items={this.fill.items}
              pagination={this.fill.pagination}
              loading={this.fill.isLoading}
              onPageChange={this.handleFillPageChange}
            />
            <Receive
              items={this.receive.items}
              pagination={this.receive.pagination}
              loading={this.receive.isLoading}
              style={{ marginTop: '1.5rem' }}
              onPageChange={this.handleReceivePageChange}
            />
            <Transfer
              items={this.transfer.items}
              pagination={this.transfer.pagination}
              loading={this.transfer.isLoading}
              style={{ marginTop: '1.5rem' }}
              onPageChange={this.handleTransferPageChange}
            />
            <div style={{ marginTop: '1.5rem' }}>
              <el-button
                style={{ display: 'block', margin: '0 auto' }}
                onClick={this.toHistoryPage}
              >
                ประวัติการโอนย้ายทอง
              </el-button>
            </div>
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
